var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M19.3945 4.56247C17.613 2.78101 15.2754 1.89431 12.9458 1.88625L12.9458 3.59516C14.8482 3.59516 16.7425 4.31258 18.1854 5.75548C19.6283 7.19838 20.3537 9.10076 20.3457 10.9951L22.0546 10.9951C22.0627 8.68159 21.176 6.34393 19.3945 4.56247Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M18.6533 11.0107C18.6452 9.55169 18.089 8.09267 16.9766 6.98027C15.8642 5.86786 14.4052 5.31166 12.9462 5.3036L12.9462 7.01251C13.9618 7.01251 14.9936 7.39943 15.7675 8.17328C16.5413 8.94713 16.9363 9.97086 16.9282 10.9946L18.6533 11.0107Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M14.3995 16.4157L11.5268 19.2657C8.67682 17.6355 6.31706 15.2757 4.68688 12.4258L7.53684 9.55303C7.79904 9.27944 7.91304 8.90324 7.84464 8.52705L6.98965 4.33191C6.88705 3.80752 6.41966 3.41992 5.87247 3.41992H1.14154C0.503145 3.41992 -0.0326477 3.95571 0.00155184 4.59411C0.195349 7.88866 1.19853 10.978 2.77171 13.6798C4.57289 16.7919 7.16065 19.3683 10.2614 21.1695C12.9632 22.7312 16.0525 23.7458 19.3471 23.9396C19.9855 23.9738 20.5213 23.438 20.5213 22.7996V18.0687C20.5213 17.5215 20.1337 17.0541 19.6093 16.9515L15.4255 16.1193C15.0493 16.0395 14.6617 16.1535 14.3995 16.4157Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }